import React from 'react';
import ReactDOM from 'react-dom';
import {destroy} from "mobx-state-tree"
import App from './App';
import * as Analytics from "./utils/Analytics";

import MainStore, {defaultStore, IMainStore} from './stores/MainStore';

let store: IMainStore;

// @ts-ignore
window.reactAppVersion = process.env.REACT_APP_VERSION;

Analytics.init();

function createStore(snapshot: any) {
    // kill old store to prevent accidental use and run clean up hooks
    if (store) destroy(store);

    // create new one
    store = MainStore.create(snapshot);
    return store
}

ReactDOM.render(<App store={createStore(defaultStore)}/>, document.getElementById('root'));
